import React from "react";
import { useLocation } from "react-router-dom";
import { SurveyWizard } from "../../components/survey/SurveyWizard";
import { treatments } from "../../utils/treatments";
import _ from "lodash";

// TODO: Refactor to bring Preliminary Survey for
// this and all treatments under one file e.g(Herpes)
const EdPreliminarySurvey = () => {
  const edSearchableTag =
    process.env.REACT_APP_ED_PRELIMINARY_SURVEY_SEARCHABLE_TAG;

  const surveyPath = _.find(treatments, {
    searchable_tag: edSearchableTag,
  })?.href;

  return (
    <SurveyWizard
      surveySearchableTag={edSearchableTag}
      treatmentSurveyPath={surveyPath}
    />
  );
};

export default EdPreliminarySurvey;
